var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-video-wrap"},[_c('div',[_c('i',{staticClass:"iconfont icon-close",on:{"click":function($event){return _vm.$emit('closed')}}}),_c('video',{ref:"videoPlayer",staticClass:"video-js"})])])}
var staticRenderFns = []

export { render, staticRenderFns }